import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './app-download.scss';

const AppDownload = () => {
  const [isRedirecting, setIsRedirecting] = useState(true);
  // const navigate = useNavigate();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

      // Detectar iOS
      if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        window.location.href = 'https://apps.apple.com/br/app/washpass/id6503068980';
        return;
      }

      // Detectar Android
      if (/android/i.test(userAgent)) {
        window.location.href = 'https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR';
        return;
      }

      setIsRedirecting(false);
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, []);

  const handleCancelRedirect = () => {
    setIsRedirecting(false);
  };

  return (
    <>
      <Navbar />
      <Box className="app-download">
        <Container maxWidth="lg">
          <Box className="app-download__content">
            {isRedirecting ? (
              <>
                <Typography variant="h4" component="h1" gutterBottom>
                  Redirecionando para a loja de aplicativos...
                </Typography>
                <Button
                  variant="outlined"
                  onClick={handleCancelRedirect}
                  sx={{ mt: 3 }}
                >
                  Cancelar redirecionamento
                </Button>
              </>
            ) : (
              <>
                <Typography variant="h4" component="h1" gutterBottom>
                  Baixe o WashPass
                </Typography>
                <Typography variant="body1" paragraph>
                  Escolha sua plataforma para baixar o aplicativo:
                </Typography>
                <Box className="app-download__buttons">
                  <Button
                    variant="contained"
                    color="primary"
                    href="https://apps.apple.com/br/app/washpass/id6503068980"
                    target="_blank"
                    sx={{ mr: 2 }}
                  >
                    App Store
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    href="https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR"
                    target="_blank"
                  >
                    Google Play
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default AppDownload;
